import { render } from "./GuardianSelectionModal.vue?vue&type=template&id=d2559efa&scoped=true"
import script from "./GuardianSelectionModal.vue?vue&type=script&lang=js"
export * from "./GuardianSelectionModal.vue?vue&type=script&lang=js"

import "./GuardianSelectionModal.vue?vue&type=style&index=0&id=d2559efa&lang=css"
import "./GuardianSelectionModal.vue?vue&type=style&index=1&id=d2559efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2559efa"]])

export default __exports__